import React from "react";
import "./video_overlay.css";

export default function VideoOverlay({ loading, videoRef, startVideo }) {
  return (
    <>
      <img className="bezel2" src="./images/tv-bezel-transp2.png" alt="LG TV" />
      {!loading ? startVideo() : null}
      <div
        ref={videoRef}
        className={!loading ? "fullvideo" : ""}
        dangerouslySetInnerHTML={{
          __html: `
      <video
        src="./video/Comp 1.mp4"
        ref={videoRef}
        muted
        preload={"auto"}
        onLoadedData={startVideo}
        playsInline
        autoplay
        type="video/mp4"
      ></video>
      `,
        }}
      ></div>
    </>
  );
}
